import { Statistic } from 'antd';
import React from 'react';

const CustomerBaseTotalIncome = ({label, value}) => {

    return(
        <React.Fragment>
            <Statistic  title={label} value={new Intl.NumberFormat().format(value)}/>
        </React.Fragment>
    )
}

export default CustomerBaseTotalIncome;